import { z } from 'zod';

import { BASE_FONT_FAMILY } from './inputs/base/FontFamilyInput';

// carlos Mar 18, 2025
// Whenever the CSS_STYLE_SCHEMA is updated we need to reflect the change
// in FCssStyle.graphql. This is one of the few parts that doesn't pick up the
// changes automatically. We should look into how to auto update it.
export const CssStyleSchema = z.object({
  backgroundColor: z.string().nullable().optional(),
  backgroundColorTemplate: z.string().nullable().optional(),
  border: z.string().nullable().optional(),
  borderRadius: z.string().nullable().optional(),
  color: z.string().nullable().optional(),
  colorTemplate: z.string().nullable().optional(),
  fontFamily: z.string().nullable().optional(),
  fontSize: z.string().nullable().optional(),
  fontWeight: z.string().nullable().optional(),
  height: z.string().nullable().optional(),
  margin: z.string().nullable().optional(),
  maxHeight: z.string().nullable().optional(),
  maxWidth: z.string().nullable().optional(),
  minHeight: z.string().nullable().optional(),
  minWidth: z.string().nullable().optional(),
  padding: z.string().nullable().optional(),
  textAlign: z.string().nullable().optional(),
  textTransform: z.string().nullable().optional(),
  width: z.string().nullable().optional(),
});

export type TCssStyle = z.infer<typeof CssStyleSchema>;
export const CSS_PROPERTY_NAMES = Object.keys(CssStyleSchema.shape) as Array<keyof TCssStyle>;

export const SectionPropsSchema = z
  .object({
    hiddenCondition: z.string().nullable().optional(),
    loopTemplate: z.string().nullable().optional(),
    loopArgumentName: z.string().nullable().optional(),
  })
  .nullable()
  .optional();

export const DEFAULT_BACKDROP_STYLE = {
  backgroundColor: '#EEEEEE',
  fontFamily: BASE_FONT_FAMILY.value,
  color: '#242424',
} satisfies TCssStyle;

export const DEFAULT_CANVAS_STYLE = {
  backgroundColor: '#FFFFFF',
} satisfies TCssStyle;

export const DEFAULT_LINKS_STYLE = {
  color: '#2458AF',
} satisfies TCssStyle;
